


















import Header from '@/containers/Header.vue'
import Footer from '@/containers/Footer.vue'
import GoTop from '@inotom/vue-go-top'
import { ROLE_ACCESS } from '@/utils/constants'

export default {
  name: 'MainContainer',
  components: {
    Header,
    Footer,
    GoTop
  },
  data: () => ({
    ROLE_ACCESS: ROLE_ACCESS
  })
}
